import { render, staticRenderFns } from "./wsGOSTSelector.vue?vue&type=template&id=087c1663"
import script from "./wsGOSTSelector.vue?vue&type=script&lang=js"
export * from "./wsGOSTSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports